// const BASE_URL_BACK = 'https://kavkaz.apidev.czmb.tech'; // 测试服
// const BASE_URL_REQUEST = 'https://kavkaz.apidev.czmb.tech/v1'; // 测试服
// const BASE_URL = "https://kavkaz.webdev.czmb.tech";//网站基础URL // 测试服

const BASE_URL_BACK = 'https://api.kavkazcargo.com'; // 正式服
const BASE_URL_REQUEST = 'https://api.kavkazcargo.com/v1'; // 正式服
const BASE_URL = "https://www.kavkazcargo.com";//网站基础URL // 正式服

const BASE_OSS = "https://btzc.oss-cn-hangzhou.aliyuncs.com";//阿里云直传图片地址
const BASS_UPLOADURL = "/api/upload/single"// 阿里OSS直传
// const BASS_UPLOADURL = "/api/local_upload/upload_file" // 本地上传
const BASE_WEBSITE_NAME = "kavkaz";//网站名称
// 注意设置默认语言，有三个地方需要调整
// 1：src\views\login\loginClient.vue---329行，默认取值语言
// 2：src\views\PageProfile\Index.vue---436行，默认取值下标
// 3：src\utils\cache\index.ts----------25行，默认语言code
const BASE_URL_REQUEST_PUSH = 'https://env-00jxho15nhol.dev-hz.cloudbasefunction.cn'; // 消息推送服务器

export {
	BASE_OSS,
	BASE_URL,
	BASE_WEBSITE_NAME,
	BASE_URL_BACK,
	BASE_URL_REQUEST,
	BASS_UPLOADURL,
    BASE_URL_REQUEST_PUSH
}